// Platform-wide PostHog Session Replay privacy controls.
// Keep these explicit rather than relying on PostHog project defaults.
// Privacy disclosures rely on masked inputs and excluded sensitive UI regions.
export const posthogReplayPrivacy = {
  enable_recording_console_log: false,
  session_recording: {
    blockSelector: '.ph-no-capture',
    maskAllInputs: true,
  },
};
